// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BillUnapplyVendorCreditDialog-body__WFynx{display:flex;flex-direction:column;gap:var(--size-4);padding:var(--size-4)}.BillUnapplyVendorCreditDialog-paragraph__cMqZA{margin-bottom:0;font:var(--font-body-400-compact);font-feature-settings:var(--feature-settings-body-400-compact);letter-spacing:var(--letter-spacing-body-400-compact)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "BillUnapplyVendorCreditDialog-body__WFynx",
	"paragraph": "BillUnapplyVendorCreditDialog-paragraph__cMqZA"
};
export default ___CSS_LOADER_EXPORT___;
